<template>
  <div class="marketing TopHeadder">
      <!-- 智能营销 -->
      <div class="bannerBox">
          <img src="../../assets/image/hot_banner.jpg" />
            <div class="bannerTitle">
             <h3>心理援助热线系统P9</h3>
          </div>
      </div>

      <div class="market_item1 PublicPadding">
         <h4 class="title">产品介绍</h4>
         <div>
           <i><img src="../../assets/image/p1_1.png"/></i>
           <p>领先科技具有16年呼叫中心系统研发经验，根据自身技术优势，结合心理咨询行业特点，开发出了心理援助热线系统P9。系统具有自动语音导航、来电弹屏、来电者资料记录、来电者自杀危险评估、全程录音、电话监控、电话转接、来电业务统计、热线咨询员服务质量评估、大数据分析等功能。心理援助热线系统P9为监控热线服务质量、评估工作效率和系统使用效率、合理分配热线服务人力、人员培训方向等提供了依据。</p>
         </div>
      </div>
      <div class="home_item2 PublicPadding colorbg">
        <h4 class="title">主要功能</h4>
        <ul class="clear">
            <li>
                <i><img src="../../assets/image/p2_1.png"/></i>
                <h3>基本功能</h3>
                <p>心理援助热线系统包括基本的通话、录音管理、语音导航、电话分配等功能。</p>
            </li>
             <li>
                <i><img src="../../assets/image/p2_2.png"/></i>
                <h3>来电弹屏</h3>
                <p>患者来电自动弹屏，识别并记录管理患者信息，包括住址、性别、年龄、患病历史等。</p>
            </li>
             <li>
                <i><img src="../../assets/image/p2_3.png"/></i>
                <h3>心理评估</h3>
                <p>心理咨询专家通过预先设定的问题，对患者心理健康进行科学评估，根据评估等级对患者进行心理干预。</p>
            </li>
             <li>
                <i><img src="../../assets/image/p2_4.png"/></i>
                <h3>来电随访</h3>
                <p>根据患者的评估等级进行随访处理，支持回访预约、回访记录等。</p>
            </li>

            <li>
                <i><img src="../../assets/image/p2_5.png"/></i>
                <h3>工单管理</h3>
                <p>将对来电患者的评估及处理情况建成工单，系统管理、记录、跟踪患者的诉求及处理结果。</p>
            </li>
            <li>
                <i><img src="../../assets/image/p2_6.png"/></i>
                <h3>知识库</h3>
                <p>心理援助热线知识库为专业化的服务提供帮助，提供知识库管理，高危来电评估流程，处理办法等。</p>
            </li>
            <li>
                <i><img src="../../assets/image/p2_7.png"/></i>
                <h3>录音监听质检</h3>
                <p>咨询通话全程录音，支持录音检索、播放、质检评分等功能。方便对咨询人员考核管理。</p>
            </li>
            <li>
                <i><img src="../../assets/image/p2_8.png"/></i>
                <h3>数据报表</h3>
                <p>完善的统计及报表系统，对来电业务、咨询人员工作效率等进行监控。</p>
            </li>
        </ul> 
     </div>
     <div class="market_item3 PublicPadding">
          <h4 class="title">系统亮点</h4>
          <h5 class="titleh5">心理援助热线系统P9将覆盖全渠道接入的用户群体，通过统一热线号码的接入，提供统一的服务界面、统一的高水平服务标准、统一的数据管理，实现心理咨询、疏导和干预和全方位覆盖。</h5>
          <ul>
             <li class="m3_li1" :class="{active:activeChild==1}" v-on:click="activeTab(1)">
               <div>
                  <i></i>
                  <h3>全媒体服务渠道接入</h3>
               </div>
             </li>
             <li class="m3_li2" :class="{active:activeChild==2}" v-on:click="activeTab(2)">
                <div>
                  <i></i>
                  <h3> 个性化定制管理</h3>
                </div>
             </li>
             <li class="m3_li3" :class="{active:activeChild==3}" v-on:click="activeTab(3)">
                <div>
                  <i></i>
                  <h3>大屏监控管理</h3>
                </div>
             </li>
             <li class="m3_li4" :class="{active:activeChild==4}" v-on:click="activeTab(4)">
               <div>
                  <i></i>
                  <h3>干预数据评估模块</h3>
                </div>
             </li>
             
          </ul>
          <ol>
             <li v-show="activeChild==1">
                <div>
                   <h3>全媒体服务渠道接入</h3>
                   <p>支持电话、微信接入，Web在线多渠道访问，实现统一排队、统一监控、统一管理、统一统计，以适应不同的患者采用不同的方式接入。</p>      
                </div>
                <i>
                  <img src="../../assets/image/p3_t1.png"/>
                </i>
             </li>
              <li v-show="activeChild==2">
                <div>
                   <h3>个性化定制管理</h3>
                   <p>可根据心理咨询行业个性需求，定制专业的业务管理模块。</p> 
                </div>
                <i>
                  <img src="../../assets/image/p3_t2.png"/>
                </i>
             </li>
             <li v-show="activeChild==3">
                <div>
                   <h3>大屏监控管理</h3>
                   <p>大屏数据展示，随时了解系统运行服务情况，包括话务数据统计、业务数据统计、热线接听分析等。</p> 
                </div>
                <i>
                  <img src="../../assets/image/p3_t3.png"/>
                </i>
             </li>
              <li v-show="activeChild==4">
               <div>
                   <h3>干预数据评估模块</h3>
                   <p>多种心理测评量表，自动统计量表分数，对应危险程度，并能按自杀危险等级提示对应处理方案。</p>  
                </div>
                <i>
                  <img src="../../assets/image/p3_t4.png"/>
                </i>
             </li>
           
          </ol>
     </div>
     <div class="p_item4 PublicPadding colorbg">
       <h4 class="title">建设优势</h4>
       <ul>
            <li class="hot4_li1">
                <h3>经验丰富</h3>
                <p>具有16年呼叫中心系统建设经验，陆续在国内多个城市开通建设数十套心理援助热线系统。</p>
            </li>
            <li class="hot4_li2">
                <h3>技术先进</h3>
                <p>领先科技将全媒体接入、AI人工智能、大数据分析等新的技术融合到心理援助热线系统，技术领先。</p>
            </li>
            <li class="hot4_li3">
                <h3>部署灵活</h3>
                <p>支持本地部署，也支持云部署方式，包括私有云和公有云部署。</p>
            </li>
            <li class="hot4_li4">
                <h3>高可靠性</h3>
                <p>支持端到端的所有部件冗灾备份，软件容错性高，系统软件和硬件稳定可靠。</p>
            </li>
       </ul>
     </div>
     <div class="p_item5 PublicPadding">
          <h4 class="title">客户案例</h4>
          <ul>
                <li>
                    <i></i>
                    <h3>杭州市第七人民医院</h3>
                </li>
                <li>
                    <i></i>
                    <h3>沈阳市精神卫生中心</h3>
                </li>
                <li>
                    <i></i>
                    <h3>义乌市精神卫生中心</h3>
                </li>
                <li>
                    <i></i>
                    <h3>无锡市精神卫生中心</h3>
                </li>
                <li>
                    <i></i>
                    <h3>镇江市精神卫生中心</h3>
                </li>
                <li>
                    <i></i>
                    <h3>富阳市第三人民医院</h3>
                </li>
                <li>
                    <i></i>
                    <h3>赣州市第三人民医院</h3>
                </li>
                <li>
                    <i></i>
                    <h3 class="lite">北京智慧果心理咨询有限公司</h3>
                </li>
                <li>
                    <i></i>
                    <h3 class="lite">杭州师范大学大学生心理危机干预热线</h3>
                </li>
                <li>
                    <i></i>
                    <h3 class="lite">杭州市卫生监督管理所心理咨询热线</h3>
                </li>
                <li>
                    <i></i>
                    <h3 class="lite">杭州市西湖政苑社区心理辅导热线</h3>
                </li>
          </ul>
     </div>
      <Popup v-show="$store.state.isshow"></Popup>
  </div> 
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'marketing',
  data () {
    return {
      activeChild:1,
      
    }
  },
  components:{
        Popup
  },
  methods:{
    popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
    },
   
    activeTab(num) {
       this.activeChild=num
    },
  }
}
</script>


<style scoped>
.audioBox{display: none;}
.bannerTitle{
   top:1.7rem;
}
.bannerTitle h3{
    font-size: 0.4rem;
}
.market_item1{
  padding-left:0.25rem;
  padding-right:0.25rem;
}
.market_item1 div{ 
  padding: 0.4rem;
  box-shadow: 0 0 0.08rem #ccc;
  margin-top:0.4rem;
}
.market_item1 p{
  font-size: 0.2rem;
  font-weight: 400;
  color: #666666;
  line-height: 0.4rem;
  margin-top:0.5rem;
  margin-bottom: 0.7rem;
}
.market_item1 i{
  display: block;
  width:3.49rem;
  height: 3.38rem;
  margin: 0.4rem auto;
  
}
.market_item1 i img{
  display: block;
  width:3.49rem;
  height: 3.38rem;
}
.market_item3 .titleh5{
    width: 6.5rem;
    margin: 0.3rem auto;
    color: #999;
}
.market_item3 ul{
  /* overflow: hidden; */
  height: 1.7rem;
  background: #eefefc;
  border-top:0.02rem solid #90e4f7;
  border-bottom:0.02rem solid #90e4f7;
  margin-top:0.4rem;
}

.market_item3 ul li{
  float: left;
  width: 1.87rem;
}
.market_item3 ul li div{
  height: 1.51rem;
  border-left: 0.01rem solid #90e4f7;
  padding-top: 0.2rem;
}
.market_item3 ul li.active{
  padding-bottom:0.2rem ;
}
.market_item3 ul li:first-child div{
  border-left: none;
}
.market_item3 ul li i{
  display: block;
  width: 0.3rem;
  height: 0.3rem;
  margin: 0 auto; 
  margin-bottom: 0.17rem;
}
.market_item3 ul li.m3_li1 i{
   background: url("../../assets/image/p3_1.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li2 i{
   background: url("../../assets/image/p3_2.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li3 i{
   background: url("../../assets/image/p3_3.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li4 i{
   background: url("../../assets/image/p3_4.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li1.active i{
   background: url("../../assets/image/p3_11.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li2.active i{
   background: url("../../assets/image/p3_22.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li3.active i{
   background: url("../../assets/image/p3_33.png") no-repeat center;
   background-size:100% 100%;
}
.market_item3 ul li.m3_li4.active i{
   background: url("../../assets/image/p3_44.png") no-repeat center;
   background-size:100% 100%;
}

.market_item3 ul li h3{
  font-size: 0.18rem;
  font-weight: 400;
  color: #00C7FF;
  line-height: 0.3rem;
  width: 1.2rem;
  margin: 0 auto;
  padding-bottom:0.25rem ;
}
.market_item3 ul li.active{
  background:url("../../assets/image/m_li.png") no-repeat center;
  background-size:100% 100%;
}
.market_item3 ul li.active h3{
  color: #fff;
}
.market_item3 ol{
  width: 7rem;
  height: 4.56rem; 
  margin:0 auto;
  margin-top: 0.5rem;
  box-shadow: 0 0 0.08rem #ccc;
  background: #fff;
}
.market_item3 ol li{
  overflow: hidden;
}
.market_item3 ol li div{
  float: left;
}
.market_item3 ol li div h3{
    width: 2.7rem;
  font-size: 0.3rem;
  font-weight: 400;
  color: #33CAF2;
  line-height: 0.3rem;
  margin: 0.8rem 0 0.3rem 0.3rem;
}
.market_item3 ol li div p{  
  font-size: 0.18rem;
  font-weight: 400;
  color: #666666;
  margin-top:0.2rem;
  margin-left: 0.3rem;
  width: 2.9rem;
}
.market_item3 ol li i{
  float: right;
  display: block;
  width:2.7rem;
  height: 3rem;
  margin:0.7rem 0.4rem 0 0;
}
.market_item3 ol li i img{
  display: block;
  width:2.7rem;
  height: 3rem;
}
.home_item2 ul{
  margin-top: 0.4rem;
}
.home_item2 ul li{
    float: left;
    width: 3.2rem;
    height: 3.8rem;
    box-shadow: 0px 0px 0.05rem 0.01rem rgba(0, 0, 0, 0.17);
    margin: 0.2rem 0.2rem 0.2rem 0.3rem;
    background: #fff;
}
.home_item2 ul li i{
    display: block;
    width: 0.78rem;
    height: 0.69rem;
    margin: 0 auto;
    margin-top: 0.44rem;
}
.home_item2 ul li i img{
    display: block;
    width: 0.78rem;
    height: 0.69rem;
}
.home_item2 ul li h3{
    font-size: 0.24rem;
    color: #333;
    font-weight: 400;
    text-align: center;
    margin: 0.15rem 0 0.3rem 0;
}
.home_item2 ul li p{
    width: 2.8rem;
    font-size: 0.2rem;
    color: #999;
    line-height: 0.36rem;
    text-align: center;
    margin: 0 auto;
}
.p_item4 ul{
    width: 4.78rem;
    height: 4.79rem;
    margin:0 auto;
    background:url("../../assets/image/p4_bg.png") no-repeat center;
    background-size:100% 100%;
    position: relative;  
    margin-top: 2.6rem;
    margin-bottom: 2.3rem;
}
.p_item4 ul li{
    width: 3.42rem;
    height: 2.48rem;
}
.p_item4 ul .hot4_li1{
    position: absolute;
    left: -1.3rem;
    top: -2rem;
    background:url("../../assets/image/p4_1.png") no-repeat center;
    background-size:100% 100%;
}
.p_item4 ul .hot4_li2{
    position: absolute;
    right: -1.3rem;
    top: -2rem;
    background:url("../../assets/image/p4_2.png") no-repeat center;
    background-size:100% 100%;
}
.p_item4 ul .hot4_li3{
    position: absolute;
    left: -1.3rem;
    bottom: -2.1rem;
    background:url("../../assets/image/p4_3.png") no-repeat center;
    background-size:100% 100%;
}
.p_item4 ul .hot4_li4{
    position: absolute;
    right: -1.3rem;
    bottom: -2.1rem;
    background:url("../../assets/image/p4_4.png") no-repeat center;
    background-size:100% 100%;
}
.p_item4 ul li h3{   
    font-size: 0.24rem;
    font-weight: 400;
    color: #333333;
    margin: 0.3rem 0 0 0.31rem;
}
.p_item4 ul li p{
    width:2.8rem;
    margin: 0 auto;
    font-size: 0.18rem;
    color: #999999;
}
.p_item4 ul li.hot4_li3 h3{
    margin-top:0.8rem;
}
.p_item4 ul li.hot4_li4 h3{
    margin-top:0.8rem;
}
.p_item5 ul{
    overflow: hidden;
    margin-top:0.4rem;
}
.p_item5 ul li{
    float: left;
    width: 3rem;
    height: 0.93rem;
    border: 0.01rem solid #ccc;
    margin: 0 0 0.2rem 0.21rem;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    overflow: hidden;
}
.p_item5 ul li i{
    float: left;
    width: 0.25rem;
    height: 0.28rem;
    background:url("../../assets/image/p5_1.png") no-repeat center;
    background-size:100% 100%;
    margin:0.3rem 0.2rem 0 0rem;
}
.p_item5 ul li h3{
    float: left;
    font-weight: 400;
    width: 2.4rem;
    font-size: 0.18rem;
    color: #666;
    margin-top: 0.3rem;
}
.p_item5 ul li h3.lite{
    margin-top: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/product/proHotline.vue